import React from "react";
import SoftBox from "components/SoftBox";
import SoftModal from "components/SoftModal";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { registerUser } from "http/authApi";
import { useMutation, useQueryClient } from "react-query";
import { createBasicAuth } from "http/basicAuthApi";
import { useTranslation } from "react-i18next";

const BasicAuthCreate = () => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const queryClient = useQueryClient()

  const { mutate, isError } = useMutation(({ username, password }) => createBasicAuth({ username, password }), {
    onSuccess: (response, formData) => {
      queryClient.invalidateQueries('basicAuths');
      setOpen(false);
    },
    onError: (error) => {
      console.log(error);
      // setError(error.response.data.message);
    },
  });

  const submitHandler = async (e) => {
    e.preventDefault();
    const username = e.target.username.value;
    const password = e.target.password.value;

    const user = { username: username, password: password };

    await mutate(user);
  };

  return (
    <SoftBox>
      <SoftButton variant="outlined" color="warning" onClick={handleOpen}>
        {t("modal.add_basic_auth")}
      </SoftButton>
      <SoftModal title={t("modal.create_basic_auth")} open={open} handleClose={handleClose}>
        <SoftBox component="form" role="form" onSubmit={submitHandler}>
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                {t("modal.username")}
              </SoftTypography>
            </SoftBox>
            <SoftInput type="text" required placeholder={t("modal.username")} id="username" name="username" />
          </SoftBox>
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                id="password"
                name="password"
              >
                {t("modal.password")}
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type={showPassword ? "text" : "password"}
              placeholder={t("modal.password")}
              id="password"
              name="password"
              required
              icon={{
                component: showPassword ? (
                  <Visibility
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={() => setShowPassword(!showPassword)}
                  />
                ) : (
                  <VisibilityOff
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={() => setShowPassword(!showPassword)}
                  />
                ),
                direction: "right",
              }}
            />
          </SoftBox>
          <SoftBox mt={4} mb={1}>
            <SoftButton type="submit" variant="gradient" color="warning">
              {t("modal.create")}
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftModal>
    </SoftBox>
  );
};

export default BasicAuthCreate;
